import { useMemo, useState } from "react";

import {
  Button,
  ChevronDownSVG,
  ChevronUpSVG,
  Icon,
  type SvgComponentType,
} from "@newsela/angelou";

import {
  getHomeMenuButtonCss,
  homeMenuVisibilityContainerCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenu.styles";
import { HomeMenuPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuPopout/HomeMenuPopout";
import { NavButtonWithPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout";
import {
  getNavMenuButtonAriaProps,
  IButtonAriaProps,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.utils";
import useUser from "@/users/useUser";
import { useNavBarItemVisibility } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useNavBarItemsVisibilityControl";
import { NavButtonWithPopoutText } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavButtonWithPopoutText/NavButtonWithPopoutText";

const MENU_ID = "nav-home-menu";

const HomeMenu = () => {
  const { data: user } = useUser();

  const [isOpen, setIsOpen] = useState(false);

  const buttonAriaProps: IButtonAriaProps = useMemo(
    () =>
      getNavMenuButtonAriaProps({
        isOpen,
        id: MENU_ID,
      }),
    [isOpen],
  );
  const { isVisible } = useNavBarItemVisibility();

  if (!user?.is_authenticated) return null;

  return (
    <NavButtonWithPopout
      id={MENU_ID}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      position={{ right: "0.5rem", top: "3.25rem" }}
      rootCustomCss={homeMenuVisibilityContainerCss(isVisible("home-menu"))}
      ButtonComponent={
        <Button
          ariaProps={buttonAriaProps}
          flavor={Button.flavors.incognito}
          onClick={() => setIsOpen(!isOpen)}
          __cssFor={getHomeMenuButtonCss(isOpen)}
          dataProps={{ "data-qa-selector": "global-nav-home-menu" }}
        >
          <NavButtonWithPopoutText>Menu</NavButtonWithPopoutText>
          {isOpen ? (
            <Icon SvgComponent={ChevronUpSVG as SvgComponentType} />
          ) : (
            <Icon SvgComponent={ChevronDownSVG as SvgComponentType} />
          )}
        </Button>
      }
      PopoutComponent={<HomeMenuPopout />}
    />
  );
};

HomeMenu.displayName = "HomeMenu";
export { HomeMenu };
